import { CodelistResponse } from 'api/models'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { useCallback } from 'react'
import { CodelistGroup } from 'features/declaration/codelist/models/types'
import { codelistQueryKeys } from '../keys'

const baseUrl = process.env.REACT_APP_API_URL

export type CodelistFilterFn = (item: CodelistResponse) => boolean

export type CodelistResult = {
  data: CodelistResponse[] | undefined
  isLoading: boolean
  isSuccess: boolean
}

function useCodelistQuery(group: CodelistGroup, filterFn?: CodelistFilterFn): CodelistResult {
  const {
    data,
    isLoading,
    isSuccess,
  } = useQuery(
    {
      queryKey: codelistQueryKeys.group(group),
      queryFn: async () => (await axios.get<CodelistResponse[]>(`${baseUrl}/v2/codelist/group/${group ?? ''}`)).data,
      select: useCallback((responses: CodelistResponse[]): CodelistResponse[] => {
        const normalized = responses ?? []
        return filterFn ? normalized.filter(filterFn) : normalized
      }, [filterFn]),
    },
  )

  return {
    data,
    isLoading,
    isSuccess,
  }
}

export default useCodelistQuery
